<template>
  <div>
    <v-row v-for="(item, index) in dataValues" :key="index">
      <v-col lg="6" md="6" align-self="center" sm="12">
        <div class="title-radar">{{ item[0].municipio }}</div>
        <v-data-table
          :headers="headers"
          :items="item"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
        </v-data-table>
      </v-col>
      <v-col lg="6" md="6" align-self="center" sm="12">
        <radar-chart
          :chart-data="fillChart(item)"
          :options="getLineChartOptions(item)"
          :width="200"
          :height="200"
        ></radar-chart>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import RadarChart from "../../../components/chart/RadarChart.vue";
import { cityAPI } from "../../city/API/CityAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    RadarChart
  },
  data() {
    return {
      dataValues: [],
      headers: [
        { text: "Eixo", value: "tema" },

        { text: "T1", value: "t1" },
        { text: "T2", value: "t2" },
        { text: "T0", value: "to" },

        { text: "Evolução", value: "evolucao" }
      ]
    };
  },
  methods: {
    ...mapActions(["setLoading"]),

    fillChart(value) {
      let dataset = [];
      let tema = [];
      tema = value.map(item => item.tema);
      dataset = [
        {
          label: "T2",
          backgroundColor: "rgba(00, 255, 255, 0.1)",
          borderColor: "#eead2d",
          borderWidth: 3,
          data: value.map(item => item.t2)
        },
        {
          label: "T1",
          backgroundColor: "rgba(00, 255, 255, 0.1)",
          borderColor: "#120a8f",
          borderWidth: 3,
          data: value.map(item => item.t1)
        },
        {
          label: "T0",
          backgroundColor: "rgba(00, 255, 00, 0.1)",
          borderColor: "#00FF00",
          borderWidth: 3,
          data: value.map(item => item.to)
        }
      ];

      return {
        labels: tema,
        datasets: dataset
      };
    },
    getLineChartOptions(value) {
      const municipio = value.map(item => item.municipio)[0];
      return {
        responsive: true,
        title: {
          display: true,
          fontColor: "blue",

          fontSize: 14,
          text: municipio
        },
        legend: {
          display: true,
          reverse: true,
          labels: {
            usePointStyle: true,
            pointStyle: "circle"
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItem, chart) => {
              const realValue =
                chart.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ];
              const customValue = realValue + "%";
              const label = chart.labels[tooltipItem.index] + ":";
              return label + customValue;
            }
          }
        },

        scale: {
          max: 100,
          min: 0,

          gridLines: {
            color: "red"
          },
          grid: {
            color: "red"
          },
          angleLines: {
            color: "red"
          },
          pointLabels: {
            fontColor: "blue",
            fontSize: 10
          },
          ticks: {
            fontColor: "blue",
            min: 0,
            max: 100,
            stepSize: 20,
            callback: function(value, index, ticks) {
              return value + "%";
            }
          }
        },
        defaultColor: "rgba(00, 255, 00, 0.1)"
      };
    },
    groupValues(itens) {
      let key = "municipioId";
      return itens.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    }
  },

  async mounted() {
    this.setLoading(true);
    await cityAPI.getRadar().then(item => {
      this.dataValues = Object.values(this.groupValues(item.data)).map(item => {
        return item.map(val => {
          return {
            evolucao: val.evolucao + "%",
            municipio: val.municipio,
            municipioId: val.municipioId,
            t1: val.t1 + "%",
            t2: val.t2 + "%",
            to: val.to + "%",
            tema: val.tema
          };
        });
      });
      this.setLoading(false);
    });
  }
};
</script>
<style scoped>
.title-radar {
  text-align: center;
  color: white;
  background: blue;
}
</style>
